import { Listbox } from '@headlessui/react';
import { LockClosedIcon, CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';

export default function ThemeDropdownWithPreview({ themes, selectedTheme, setSelectedTheme, onLockedThemeClick }) {
  return (
    <Listbox value={selectedTheme} onChange={(theme) => {
      if (theme.is_available === 0) {
        onLockedThemeClick(theme);
      } else {
        setSelectedTheme(theme);
      }
    }}>
      <div className="relative mt-1">
        {/* Trigger Button */}
        <Listbox.Button className="relative w-full cursor-default rounded border border-gray-300 bg-white py-2 pl-3 pr-10 text-left shadow-sm text-sm">
          <div className="flex items-center gap-2">
            <img
              src={selectedTheme?.theme_url}
              alt={selectedTheme?.theme_name}
              className="w-6 h-6 rounded object-cover"
            />
            <span className="block truncate">{selectedTheme?.theme_name}</span>
          </div>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" />
          </span>
        </Listbox.Button>

        {/* Dropdown List */}
        <Listbox.Options className="absolute z-10 mt-1 w-full max-h-60 overflow-auto rounded bg-white py-1 text-sm shadow-lg ring-1 ring-black/5">
          {themes.map((theme) => (
            <Listbox.Option
              key={theme.theme_meta_unique_id}
              value={theme}
              className={({ active }) =>
                `relative cursor-pointer select-none px-3 py-2 ${
                  active ? 'bg-blue-100 text-blue-900' : 'text-gray-900'
                }`
              }
            >
              {({ selected }) => (
                <div className="flex items-center gap-3">
                  <img
                    src={theme.theme_url}
                    alt={theme.theme_name}
                    className="w-10 h-10 rounded object-cover border border-gray-300"
                    loading="lazy"
                  />
                  <span className="truncate">{theme.theme_name}</span>
                  {theme.is_available === 0 && (
                    <LockClosedIcon className="w-4 h-4 text-yellow-500 ml-auto" />
                  )}
                  {selected && (
                    <CheckIcon className="w-4 h-4 text-green-500 ml-2" />
                  )}
                </div>
              )}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </div>
    </Listbox>
  );
}
